import { getDocs, collection, query, where, orderBy, getDoc, doc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

// Obtener todos los productos o filtrar por categoría
export const getProductos = async (categoryId) => {
    try {
        const collectionRef = categoryId 
            ? query(collection(db, 'productos'), where('category', '==', categoryId)) 
            : query(collection(db, 'productos'), orderBy('category', 'desc'));
        
        const response = await getDocs(collectionRef);
        return response.docs.map(doc1 => ({
            id: doc1.id,
            ...doc1.data()
        }));
    } catch (error) {
        console.error('Error al obtener productos:', error);
        return [];
    }
};

// Obtener producto por ID
export const getProductosbyId = async (productoId) => {
    try {
        const productoRef = doc(db, 'productos', productoId);
        const response = await getDoc(productoRef);
        
        // Verificar si el documento existe
        if (!response.exists()) {
            return null;
        }
        
        return {
            id: response.id,
            ...response.data()
        };
    } catch (error) {
        console.error('Error al obtener producto:', error);
        return null;
    }
};